// components/color.ts

// ヘッダー
export const headerBgColor = "commonTableHeader";

// フッター
export const footerBgColor = "grey.800";
export const footerTextColor = "white";

// モーダルウィンド
export const modalBgColor = "background.paper";
export const modalBorderColor = "#ddd";
export const modalCloseIconColor = "grey.600";

// ローディングスピナー
export const loadingBackdropColor = "#fff";
export const loadingSpinnerColor = "primary";

// サイドメニュー
export const sidebarTextColor = "black";
export const sidebarBackgroundColor = "transparent";
export const sidebarSelectedBackgroundColor = "#b3e5fc";
